$(document).ready(function(){
  var calculate_total = function(){
    var monetary   = $('#goal_selector').find(":selected").attr('data_monetary');
    var goal_title = $('#goal_selector').find(":selected").attr('data_title');
    var goal_number = $('#goal_number').val();
    $('#goal_title').html(goal_title);
    var goal_total = goal_number*monetary;
    $('#total_goal').html("Campaign Total Monetary Goal "+goal_total);
  }

  $( function() {
    var dateFormat = "mm/dd/yy",
      from = $( ".ui-start-date" )
        .datepicker()
        .on( "change", function() {
          to.datepicker( "option", "minDate", getDate( this ) );
        }),
      to = $( ".ui-end-date" ).datepicker()
      .on( "change", function() {
        from.datepicker( "option", "maxDate", getDate( this ) );
      });

    function getDate( element ) {
      var date;
      try {
        date = $.datepicker.parseDate( dateFormat, element.value );
      } catch( error ) {
        date = null;
      }

      return date;
    }
  } );

  calculate_total();
  // $('.ui-date').datepicker();
  $('#goal_selector').on("change", function(){calculate_total()});
  $('#goal_number').on("change", function(){calculate_total()});
  $(".activate_terms").on('click', function(){
    $('.terms_wrap').css('display','block');
  });

  $(".image-choice").on('click', function(){
    $(".image-choice").css("border", "0px");
    $("input[name='campaign_photo']").val($(this).attr('data-image-selection'));
    $(this).css("border", "3px solid rgb(41, 136, 190)");
  });
  var current_image = $("input[name='campaign_photo']").val();
  $(".image-choice[data-image-selection='"+current_image+"']").css("border", "1px solid rgb(41, 136, 190)");

  $("#campaign-creation-validation").submit(function(event){
    $(".alert-image").css("display", "none");
    if($("input[name='campaign_photo']").val() == ""){
      $(".alert-image").css("display", "block");
      event.preventDefault();
    }
  });

  $("#campaign-creation-validation").parsley();

  window.Parsley.addValidator('youtubeUrl',{
    requirementType:'regexp',
    validateString: function(value, requirement){
      var test1 = /https:\/\/www.youtube.com\/watch\?v=([A-Z0-9a-z-_])\w+/.test(value);
      var test2 = /www.youtube.com\/watch\?v=([A-Z0-9a-z-_])\w+/.test(value);
      var test3 = /https:\/\/youtu.be\/([A-Z0-9a-z-_])\w+/.test(value);
      if(test1 === true || test2 === true || test3 === true){
        return true;
      }else{
        return false;
      }
    },
    messages:{
      en:'This must be a valid youtube url.'
    }
  });

  // $("#goal_number").keyup(function(){
  // var target = $("#affiliate-goal-break");
  // var approximate_money = (target.attr('data_goal')*$(this).val()).toFixed(2);
  // $("#affiliate-goal-break").text("Approximatly $"+approximate_money+" could be raised. ");
  // });


});
